import { Component, Input, Output } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { FormType, NGX_SUB_FORM_HANDLE_VALUE_CHANGES_RATE_STRATEGIES, createForm, subformComponentProviders } from "ngx-sub-form";
import { Subject } from "rxjs";
import { UserRoles } from "./user-model";

@Component({
    selector: 'app-user-permissions-form',
    template: `
      <form [formGroup]="form.formGroup" class="space-y-2">
        <div class="flex">
          <p-checkbox inputId="admin" size="small" binary="true" [formControlName]="form.formControlNames.admin"></p-checkbox>
          <label class="ml-2 pt-1" for="admin">Admin</label>
        </div>

        <div class="flex">
          <p-checkbox inputId="catalogAdmin" size="small" binary="true" [formControlName]="form.formControlNames.catalogAdmin"></p-checkbox>
          <label class="ml-2 pt-1" for="catalogAdmin">Catalog Admin</label>
        </div>

        <div class="flex">
          <p-checkbox inputId="readOnly" size="small" binary="true" [formControlName]="form.formControlNames.readOnly"></p-checkbox>
          <label class="ml-2 pt-1" for="readOnly">Read Only</label>
        </div>
      </form>
    `,
    providers: subformComponentProviders(UserPermissionsFormComponent),
    standalone: false
})
export class UserPermissionsFormComponent {

  private input$ = new Subject<UserRoles | undefined>();

  @Input() set userRoles(userProfile: UserRoles | undefined) {
    this.input$.next(userProfile);
  }

  private disabled$ = new Subject<boolean>();
  @Input() set disabled(value: boolean | undefined) {
    this.disabled$.next(!!value);
  }

  @Output() userRolesUpdated = new Subject<UserRoles>();

  public form = createForm<UserRoles, UserRoles>(this, {
    formType: FormType.SUB,
    disabled$: this.disabled$,
    input$: this.input$,
    output$: this.userRolesUpdated,
    formControls: {
      admin: new UntypedFormControl(false),
      catalogAdmin: new UntypedFormControl(false),
      readOnly: new UntypedFormControl(false),
    },
    handleEmissionRate: NGX_SUB_FORM_HANDLE_VALUE_CHANGES_RATE_STRATEGIES.debounce(1000)
  });
}